module.exports = __webpack_public_path__ + "static/media/img_network_null.d444b816.svg";